import url from './url';
import request from './request';
import { LocalStorage } from '~/helpers';

const uploadFile = async (data, messageID = null) => {
  const formData = new FormData();

  formData.append('file', data);

  let requestUrl = url.processFile;

  if (messageID !== null) {
    requestUrl += `?messageID=${messageID}`;
  }

  return request(requestUrl, {
    method: 'POST',
    data: formData,
    isFile: true,
    headers: {
      Authorization: `Bearer ${LocalStorage.getToken()}`,
    },
  });
};

const checkAreResourcesAccessible = async (fileUrls) => {
  try {
    await Promise.all(fileUrls.map((fileUrl) => request(fileUrl)));

    return true;
  } catch (e) {
    return false;
  }
};

export { uploadFile, checkAreResourcesAccessible };
